/*
 *  Refresh the CSRF token for AJAX calls
 */

var timer = 300; //Number of seconds

 setInterval( () => {

 	$.ajax({
	    url 		: "/system/rfcsrf",
	    type 		: 'GET',

	    success 	: function ( result ) {

	        $('meta[name="csrf-token"]').attr('content', result );

	        $.ajaxSetup({
	            headers: {
	                'X-CSRF-TOKEN': result
	            }
	        });
	    },

	    error: function (xhr, status, error) {
	        console.log(xhr);
	    }
	});


 }, timer * 1000 );